<template>
    <div class="centerPage">
        <div class="search">
            <span class="tit">优惠券管理</span>
            
            <div class="search-block">
                <el-select v-model="page.isValid" @change="search" placeholder="筛选" class="search-select">
                    <el-option label="可用" value='1'></el-option>
                    <el-option label="不可用" value='0'></el-option>
                </el-select>
                <el-input class="search-input" v-model="page.search" placeholder="优惠券名称" @change="search"></el-input>
                <el-button @click="search">搜索</el-button>
                <el-button style="float:right;" @click="openAddDialog">新增优惠券</el-button>
            </div>
        </div>
        <div class="border">
            <el-tabs v-model="activeType" class="tabs" @tab-click="changeTabType">
                <el-tab-pane v-for="(item,ind) in couponTypes" :key="ind" :label="item.name" :name="item.code">
                    <el-table
                            class="record-table"
                            :data="tableData"
                            :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                            height="calc(100vh - 400px)">
                        <el-table-column label="分享"
                                         align="center"
                                         width="50">
                            <i class="el-icon-share" slot-scope="scope" @click="copyShareLink(scope.row)"></i>
                        </el-table-column>
                        <el-table-column
                                prop="couponTitle" show-overflow-tooltip
                                label="优惠券名称" align="center"
                                width="180">
                        </el-table-column>
                        <el-table-column align="center" label="折扣金额(元)" width="100">
                            <template slot-scope="scope">
                                {{scope.row.discountAmount?(scope.row.discountAmount/100):'-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="discountRate" align="center" label="折扣率" width="100">
                            <template slot-scope="scope">
                                {{scope.row.discountRate?(scope.row.discountRate/100):'-'}}
                            </template>
                        </el-table-column>
                        
                        <el-table-column align="center" label="有效状态" width="100">
                            <template slot-scope="scope">
                                <span @click="changeStatus(scope.row)" :class="scope.row.couponStatus == 1 ? 'blue' : 'disabled'" style="cursor:pointer;">
                                    {{ scope.row.couponStatus == 1 ? '有效' : '无效' }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="领取方式" width="100">
                            <template slot-scope="scope">
                                <span @click="changeReceiveStatus(scope.row)" :class="scope.row.receiveStatus == 1 ? 'blue' : 'disabled'" style="cursor:pointer;">
                                    {{ scope.row.receiveStatus == 1 ? '所有人可领' : '仅分享' }}
                                </span>
                            </template>
                        </el-table-column>
                        
                        <el-table-column align="center" label="开始使用时间" width="120">
                            <template slot-scope="scope">
                                {{ new Date(scope.row.startUseDate).Format('yyyy/MM/dd') }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"
                                         label="结束使用时间" width="120">
                            <template slot-scope="scope">
                                {{ new Date(scope.row.endUseDate).Format('yyyy/MM/dd') }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"
                                         label="销售价格(元)" width="120">
                            <template slot-scope="scope">
                                {{ scope.row.price | filterMoney }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"
                                         prop="useLimitCount"
                                         label="使用限制次数" width="120">
                        </el-table-column>
                        <el-table-column align="center"
                                         prop="provideCount"
                                         label="发放数量" width="100">
                        </el-table-column>
                        <el-table-column align="center" label="发放时间" width="120">
                            <template slot-scope="scope">
                                {{ new Date(scope.row.provideDate).Format('yyyy/MM/dd') }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="开始领取时间" width="120">
                            <template slot-scope="scope">
                                {{ scope.row.startReceiveDate?new Date(scope.row.startReceiveDate).Format('yyyy/MM/dd'):'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="结束领取时间" width="120">
                            <template slot-scope="scope">
                                {{ scope.row.endReceiveDate?new Date(scope.row.endReceiveDate).Format('yyyy/MM/dd'):'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"
                                         prop="receiveCount"
                                         label="已领取数量" width="100">
                        </el-table-column>
                        <el-table-column align="center"
                                         label="是否可叠加使用" width="120">
                            <template slot-scope="scope">
                                {{ scope.row.stackable == 1 ? '是' : '否' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"
                                         label="最低使用满足金额(元)"
                                         width="180">
                            <template slot-scope="scope">
                                {{scope.row.fullReductionAmount|filterMoney}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip
                                         prop="couponExplain"
                                         label="说明" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <!--      <div class="empty">
                    <img src="../../assets/img/no.png" alt="" width="200">
                    <p>这里什么都没有</p>
                  </div>-->
            <el-pagination
                    class="pagination"
                    background
                    prev-text="Prev"
                    next-text="Next"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-size="page.size"
                    layout="prev, pager, next"
                    :total="page.total">
            </el-pagination>
        </div>
        
        <el-dialog class="registrationMethod" :close-on-click-modal="false" :close-on-press-escape="false"
                   :visible.sync="addDialogVisible" title="新增优惠券" top="0"
                   width="520px">
            <el-form ref="form" label-width="130px" label-suffix="：" :model="couponInfo" class="couForm">
                <el-form-item label="优惠券类型">
                    <el-radio-group v-model="couponInfo.couponType">
                        <el-radio :label="1">优惠券</el-radio>
                        <el-radio :label="2">月卡</el-radio>
                        <el-radio :label="3">年卡</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="优惠券名称" required>
                    <el-input v-model="couponInfo.couponTitle" placeholder="请输入优惠券名称(10个字以内)" maxlength='12'></el-input>
                </el-form-item>
                <template v-if="couponInfo.couponType==1">
                    <el-form-item label="折扣方式">
                        <el-radio-group v-model="couponInfo.discountMode">
                            <el-radio :label="1">折率</el-radio>
                            <el-radio :label="2">定额</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="折扣金额" v-if="couponInfo.discountMode==2">
                        <el-input-number v-model="couponInfo.discountAmount" :min="1" placeholder="折扣金额">
                            <i slot="suffix">元</i>
                        </el-input-number>
                    </el-form-item>
                    <el-form-item label="折扣率" v-if="couponInfo.discountMode==1">
                        <el-input-number v-model="couponInfo.discountRate" :min="1" :max="99" placeholder="折扣率"></el-input-number>
                        <i style="color: #C0C4CC;margin-left: 10px">0-100之间</i>
                    </el-form-item>
                </template>
                <el-form-item label="销售价格" required v-if="couponInfo.couponType!=1">
                    <el-input type="number" @change="keepDecimal" v-model="couponInfo.price" placeholder="请输入销售价格"><i slot="suffix">元</i></el-input>
                </el-form-item>
                <el-form-item label="最低使用满足金额" v-if="couponInfo.couponType==1">
                    <el-input type="number" @change="keepDecimal" min="0" max="100" step="0.01" v-model="couponInfo.fullReductionAmount" placeholder="请输入最低使用满足金额"><i slot="suffix">元</i></el-input>
                </el-form-item>
                <el-form-item label="开始使用时间" required>
                    <el-date-picker
                            v-model="couponInfo.startUseDate"
                            type="datetime"
                            placeholder="开始使用时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束使用时间" required>
                    <el-date-picker
                            v-model="couponInfo.endUseDate"
                            type="datetime"
                            placeholder="结束使用时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="领取途径">
                    <el-radio-group v-model="couponInfo.receiveStatus">
                        <el-radio :label="1">所有人可领</el-radio>
                        <el-radio :label="0">仅私信分享</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="开始领取时间" required v-if="couponInfo.receiveStatus==1">
                    <el-date-picker
                            v-model="couponInfo.startReceiveDate"
                            type="datetime"
                            placeholder="开放领取用时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束领取时间" required v-if="couponInfo.receiveStatus==1">
                    <el-date-picker
                            v-model="couponInfo.endReceiveDate"
                            type="datetime"
                            placeholder="结束领取时间">
                    </el-date-picker>
                </el-form-item>
                
                <template>
                    <el-form-item label="发放数量">
                        <el-input-number :min="1" v-model="couponInfo.provideCount" placeholder="请输入发放数量"></el-input-number>
                    </el-form-item>
                    <el-form-item label="是否可叠加使用" v-if="couponInfo.couponType==1">
                        <el-radio-group v-model="couponInfo.stackable">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    
                </template>
                <template v-if="couponInfo.couponType!=1">
                    <el-form-item label="使用限制次数">
                        <el-input-number v-model="couponInfo.useLimitCount" placeholder="请输入使用限制次数"></el-input-number>
                    </el-form-item>
                </template>
                <el-form-item label="说明">
                    <el-input type="textarea" :rows="3" v-model="couponInfo.couponExplain" placeholder="请输入说明(200字以内)" maxlength></el-input>
                </el-form-item>
                <div class="btnGroup flex">
                    <el-button @click="addDialogVisible=false" plain class="prev">取消</el-button>
                    <el-button class="next" @click="onSubmit" :loading="addBtnLoading">新增</el-button>
                </div>
            </el-form>
        </el-dialog>
    
        <input id="el_copy_input" v-model="share_link" type="text" style="display: none">
    </div>

</template>

<script>
import base from '@/api/common';
export default {
    name: "coupon",
    data() {
        return {
            activeType: '1',
            page: {
                search:'',
                isValid: '1',
                current: 1,
                size: 10,
                total: 12
            },//关于分页
            couponTypes: [
                {name:'优惠券',code: '1'},
                {name:'月卡',code: '2'},
                {name:'年卡',code: '3'}],
            tableData: [],
            addDialogVisible: false,
            addBtnLoading: false,
            couponInfo: {
                couponExplain: "",
                couponTitle: "",
                couponType: 1,
                discountAmount: 0,
                discountMode: 1,
                discountRate: 0,
                doctorId: "",
                endReceiveDate: "",
                endUseDate: "",
                fullReductionAmount: '',
                price: 0,
                provideCount: 1,
                receiveStatus: 1,
                remark: '',
                stackable: 1,
                startReceiveDate: "",
                startUseDate: "",
                useLimitCount: 1,
            },
            share_link: '',
        }
    },
    mounted() {
        this.getData();
    },
    filters: {
        filterMoney(num) {
            if(!num){return '-'}
            return (num / 100).toFixed(2)
        }
    },
    methods: {
        copyShareLink(item){
            if(item && item.id){
                let account = localStorage.getItem('curAccount');
                this.share_link = base.web_url + '/'+account+'?share_id=' + item.id;
                document.getElementById('el_copy_input').style.display = 'block';
                this.$nextTick(() => {
                    document.getElementById('el_copy_input').select();
                    document.execCommand("copy");
                    document.getElementById('el_copy_input').style.display = 'none';
                });
                this.$message.success('领取地址已复制至剪切板');
            }
        },
        changeReceiveStatus(item){
            if(item && item.id){
                let targetStatus = (item.receiveStatus+1)%2;
                this.$messageBox.confirm('确认要将领取方式更改为"'+(targetStatus==0?'仅通过分享':'所有人可领取')+'"吗?','提示',{type: 'warning'}).then(()=>{
                    this.$ajax.post(base.basePath + 'coupon/coupon-rule/authorize/update/receiveStatus/'+item.id+'/'+targetStatus).then(res=>{
                        if(res.data.status === 'success'){
                            item.receiveStatus = targetStatus;
                        }else{
                            this.$message.error(res.data.message);
                        }
                    }).catch(err=>{
                        console.error(err);
                        this.$message.error('操作失败');
                    });
                }).catch(()=>{});
            }
        },
        changeStatus(item){
            if(item && item.id){
                let targetStatus = (item.couponStatus+1)%2;
                this.$messageBox.confirm('确认要使优惠券'+(targetStatus==0?'失效':'生效')+'吗?','提示',{type: 'warning'}).then(()=>{
                    this.$ajax.post(base.basePath + 'coupon/coupon-rule/authorize/update/status/'+item.id+'/'+targetStatus).then(res=>{
                        if(res.data.status === 'success'){
                            item.couponStatus = targetStatus;
                        }else{
                            this.$message.error(res.data.message);
                        }
                    }).catch(err=>{
                        console.error(err);
                        this.$message.error('操作失败');
                    });
                }).catch(()=>{});
            }
        },
        keepDecimal(){
            // 金额数值保留两位
            let price = this.couponInfo.price;
            if(price){ this.couponInfo.price = Number(price).toFixed(2); }
            let fullAmount = this.couponInfo.fullReductionAmount;
            if(fullAmount){ this.couponInfo.fullReductionAmount = Number(fullAmount).toFixed(2); }
        },
        changeTabType(){
            this.page.current = 1;
            this.getData();
        },
        search(){
            this.page.current = 1;
            this.getData();
        },
        getData(){
            let that = this;
            let data = {
                page: that.page.current,
                size: that.page.size,
                couponType: that.activeType,
                couponTitle: that.page.search,
                isValid: that.page.isValid
            };
            this.$ajax.post(base.basePath + 'coupon/coupon-rule/authorize/page/condition',data).then(res=>{
                if(res.data.status === 'success'){
                    this.page.current = res.data.current;
                    this.page.size = res.data.size;
                    this.page.total = res.data.total;
                    this.tableData = res.data.rows;
                }else{
                    this.$message.error('数据加载失败!');
                }
            }).catch(err=>{
                console.error('err: ' + err);
                this.$message.error('数据加载失败!');
            });
        },
        handleSizeChange(val) {
            this.page.current = 1;
            this.page.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page.current = val;
            this.getData();
        },
        onSubmit() {
            //字段校验
            if($.trim(this.couponInfo.couponTitle).length===0){this.$message.warning('优惠券名称不能为空');return}
            if(this.couponInfo.couponType==1){ //优惠券
                if(this.couponInfo.discountMode==1){
                    if(this.couponInfo.discountRate <=0 || this.couponInfo.discountRate >=100){this.$message.warning('折率范围0-100');return;}
                }else{
                    if(this.couponInfo.discountAmount <=0){this.$message.warning('折扣金额不小于0');return;}
                    if(this.couponInfo.fullReductionAmount && this.couponInfo.discountAmount>=this.couponInfo.fullReductionAmount){
                        this.$message.warning('最低使用金额不能低于折扣金额');return;
                    }
                }
            }else{
                if(!this.couponInfo.price || this.couponInfo.price <= 0){ this.$message.warning('价格不小于0'); return;}
            }
            if(!this.couponInfo.startUseDate){ this.$message.warning('开始使用时间不能为空'); return; }
            if(!this.couponInfo.endUseDate){ this.$message.warning('结束使用时间不能为空');return;}
            if(this.couponInfo.endUseDate.getTime()<=new Date().getTime()){ this.$message.warning('结束使用时间不能小于当前时间');return; }
            if(this.couponInfo.endUseDate.getTime()<=this.couponInfo.startUseDate .getTime()){this.$message.warning('开始使用时间不能大于结束使用时间');return;}
            
            if(this.couponInfo.receiveStatus==1){
                if(!this.couponInfo.startReceiveDate){ this.$message.warning('开放领取时间不能为空');return;}
                if(!this.couponInfo.endReceiveDate){ this.$message.warning('结束领取时间不能为空');return;}
                if(this.couponInfo.endReceiveDate.getTime()<=new Date().getTime()){ this.$message.warning('结束领取时间不能小于当前时间');return; }
                if(this.couponInfo.endReceiveDate.getTime()<=this.couponInfo.startReceiveDate.getTime()){this.$message.warning('开始领取时间不能大于结束领取时间');return;}
            }
            
            let data = JSON.parse(JSON.stringify(this.couponInfo));
            // 时间处理
            data.endReceiveDate = data.endReceiveDate?new Date(data.endReceiveDate).Format('yyyy-MM-dd HH:mm:ss'):'';
            data.endUseDate = data.endUseDate?new Date(data.endUseDate).Format('yyyy-MM-dd HH:mm:ss'):'';
            data.startReceiveDate = data.startReceiveDate?new Date(data.startReceiveDate).Format('yyyy-MM-dd HH:mm:ss'):'';
            data.startUseDate = data.startUseDate?new Date(data.startUseDate).Format('yyyy-MM-dd HH:mm:ss'):'';
            
            // 金额处理
            data.price = Number(data.price)*100;
            if(data.fullReductionAmount){data.fullReductionAmount = Number(data.fullReductionAmount)*100;}
            if(data.discountAmount){data.discountAmount = Number(data.discountAmount)*100}
            
            this.addBtnLoading = true;
            this.$ajax.post(base.basePath + 'coupon/coupon-rule/authorize/add', data).then(res=>{
                if(res.data.status === 'success'){
                    this.addDialogVisible = false;
                    this.$message.success('保存成功');
                    this.page.current=1;
                    this.getData();
                }else{
                    this.$message.error(res.data.message);
                }
                this.addBtnLoading = false;
            }).catch(err=>{
                console.error(err);
                this.addBtnLoading = false;
                this.$message.error('操作失败');
            })
        },
        openAddDialog(){
            this.couponInfo.couponExplain = "";
            this.couponInfo.couponTitle = "";
            this.couponInfo.couponType = 1;
            this.couponInfo.discountAmount = 0;
            this.couponInfo.discountMode = 1;
            this.couponInfo.discountRate = 0;
            this.couponInfo.doctorId = "";
            this.couponInfo.endReceiveDate = "";
            this.couponInfo.endUseDate = "";
            this.couponInfo.fullReductionAmount = '';
            this.couponInfo.price = 0;
            this.couponInfo.provideCount = 1;
            this.couponInfo.receiveStatus = 1;
            this.couponInfo.remark = '';
            this.couponInfo.stackable = 1;
            this.couponInfo.startReceiveDate = "";
            this.couponInfo.startUseDate = "";
            this.couponInfo.useLimitCount = 1;
            this.addDialogVisible = true;
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../assets/css/coupon.scss';
.search{
    height: 68px;
    padding: 10px 20px;
    .search-block{
        margin: 10px 0;
        .search-input{
            display: inline-block;
            width: 200px;
            height: 30px;
            line-height: 30px;
            margin-right: 10px;
        }
    }
}


</style>
<style lang="css">
.couForm .el-form-item__content .el-input-number input.el-input__inner {width: inherit; height: 40px; line-height: 40px;}
.search-input input,.search-select input{height: 30px; line-height: 30px;}
.search-select{width: 120px;margin-right: 8px}
.search-select .el-input__suffix{top:5px}
.search-select div.is-focus .el-input__suffix{top:-5px}
.el-icon-share{cursor: pointer;
    background: #849fff;
    color: #FFF;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    line-height: 22px;}
</style>